import { TOGGLE_COLLAPSABLE_EXPANDED_ITEM } from '../mutations/_types';

export default (state) =>
  ({ [TOGGLE_COLLAPSABLE_EXPANDED_ITEM]: toggleItem }) => {
    const { collapsableExpandedItems } = state;

    return {
      props: {
        toggleItem(facetName, category) {
          toggleItem({
            facetName,
            category,
            expanded: !collapsableExpandedItems[facetName][category],
          });
        },
      },
      getExpandedItems: (facetName) => collapsableExpandedItems[facetName],
    };
  };
